import React from "react";
import { Helmet } from "react-helmet";
import ui from "../assets/ui.jpg";
import Contactfooter from "./contactfooter";
import ContactComponent from "./ContactComponent";
import image1 from "../assets/carousel/image1.webp";
import image2 from "../assets/carousel/image2.webp";
import image3 from "../assets/carousel/image3.webp";
import image4 from "../assets/carousel/image4.webp";
import figma from "../assets/services/figma.png";
import photoshop from "../assets/services/photoshop.png";

const imageData = [
  {
    src: image1,
    text: "We provide top-notch web development services tailored to your business needs.",
  },
  {
    src: image2,
    text: "Our e-commerce solutions help businesses establish a strong online presence.",
  },
  {
    src: image3,
    text: "Experience stunning web designs that enhance user engagement and experience.",
  },
  {
    src: image4,
    text: "Responsive and mobile-friendly designs to ensure accessibility on all devices.",
  },
];

const UXUi = () => {
  return (
    <>
      <Helmet>
        <title>Ui/Ux Design | theKrisoft</title>
        <meta
          name="description"
          content="The Krisoft provides top-notch UI/UX design services, ensuring seamless and user-centric digital experiences."
        />
        <meta
          name="keywords"
          content="UI UX design, user experience, interface design, The Krisoft, digital products, intuitive design, user engagement"
        />
        <meta name="author" content="The Krisoft" />
      </Helmet>

      {/* <div className="h-44" style={{
        backgroundImage: `url(${ui})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}>
        <div className=" text-center bg-opacity-75 p-4 rounded-lg shadow-md">
          <h4 className="text-2xl font-semibold text-white">UX-UI Design</h4>
          <hr className="h-0.5 w-24 mx-auto bg-orange-500 border-0 my-2" />
          <p className=" italic text-white text-1xl">Start with Krisoft</p>
        </div>
      </div> */}

      <div
        className="bg-cover bg-center relative flex items-center justify-center md:justify-end"
        style={{ backgroundImage: `url(${ui})`, height: "80vh"  }}
      >
        <div className="w-full max-w-xs bg-[rgba(255,255,255,0.8)] p-4 rounded-lg shadow-lg mx-auto md:mx-0 md:mr-16 md:max-w-sm">
          <ContactComponent />
        </div>
      </div>

      {/* information content */}
      {/* first content */}
      <div className=" mx-auto">
        {/* Section 1: Graphic Design */}
        <div className="bg-gray-200 p-5">
          <p className="text-4xl text-center">Ui/Ux</p>
          <hr className="bg-orange-700 h-1 w-40 mx-auto my-2" />
          <div className="container p-6 flex flex-col lg:flex-row items-center gap-6">
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="https://img.freepik.com/free-vector/graphic-designer-concept-illustration_114360-847.jpg"
                alt="Graphic Designer Illustration"
                className="w-full max-w-md h-80 animate-moveUpDown"
              />
            </div>
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h4 className="text-orange-700 text-3xl lg:text-5xl">
                Graphic Design
              </h4>
              <ul className="mt-5 list-disc list-inside text-sm md:text-base">
                <li>
                  Creating visually appealing logos and branding materials.
                </li>
                <li>Professional UI designs for websites and apps.</li>
                <li>Custom illustrations and vector artwork.</li>
                <li>
                  Marketing materials like brochures and social media posts.
                </li>
                <li>Photo editing and retouching services.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Section 2: Print & Digital Media */}
        <div className="bg-gray-300 p-5">
          <div className="container p-6 flex flex-col lg:flex-row items-center gap-6">
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h4 className="text-orange-700 text-3xl lg:text-5xl">
                Print & Digital Media
              </h4>
              <ul className="mt-5 list-disc list-inside text-sm md:text-base">
                <li>Designing business cards, posters, and flyers.</li>
                <li>Creating engaging social media graphics.</li>
                <li>Professional website banners and ad creatives.</li>
                <li>Infographics and presentation design.</li>
                <li>Ensuring print-ready and digital-friendly designs.</li>
              </ul>
            </div>
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="https://img.freepik.com/free-vector/creative-process-concept-illustration_114360-1877.jpg"
                alt="Creative Process Illustration"
                className="w-full max-w-md h-80 animate-moveUpDown"
              />
            </div>
          </div>
        </div>

        {/* Section 3: Brand Identity */}
        <div className="bg-gray-200 p-5">
          <div className="container p-6 flex flex-col lg:flex-row items-center gap-6">
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="https://img.freepik.com/free-vector/branding-concept-illustration_114360-7865.jpg"
                alt="Branding Concept Illustration"
                className="w-full max-w-md h-80 animate-moveUpDown"
              />
            </div>
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h4 className="text-orange-700 text-3xl lg:text-5xl">
                Brand Identity
              </h4>
              <ul className="mt-5 list-disc list-inside text-sm md:text-base">
                <li>Consistent branding across all platforms.</li>
                <li>Logo design and visual identity guidelines.</li>
                <li>Typography, color schemes, and iconography.</li>
                <li>Custom packaging and label designs.</li>
                <li>Brand storytelling through visuals.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* what we used */}
      <div className="bg-[#FAEBCC] p-4">
        <div className="mt-9 mb-11 md:mt-16">
          <h3 className="text-center text-3xl text-red-800 font-bold mb-6">
            <span className="font-dancing pr-4 text-4xl">Technologies</span>
            UI/UX Design
          </h3>
          <hr className="bg-red-800 mt-6 h-1 w-36 mx-auto mb-14" />
          <div className="flex flex-wrap gap-6 mt-10 justify-center">
            <div className="flex flex-col items-center">
              <img
                src={photoshop}
                alt="Adobe Photoshop"
                className="shadow-md w-32 p-2 bg-slate-100 h-24 hover:shadow-xl transition duration-300 rounded-lg bg-transparent border-gray-400 border"
              />
              <p className="mt-2 text-sm font-medium text-gray-700">
                Adobe Photoshop
              </p>
            </div>
            <div className="flex flex-col items-center">
              <img
                src={figma}
                alt="Figma"
                className="shadow-md w-28 p-2 bg-slate-100 h-24 hover:shadow-xl transition duration-300 rounded-lg bg-transparent border-gray-400 border"
              />
              <p className="mt-2 text-sm font-medium text-gray-700">Figma</p>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center px-6 py-10">
        <h1 className="text-4xl font-bold">
          Benefits of Website Development with The Krisoft
        </h1>
        <p className="mt-6 text-lg">
          We offer comprehensive web design services in Mumbai and beyond,
          working closely with clients to ensure their website aligns with
          business goals.
        </p>
      </div>

      <div className="w-4/5 mx-auto py-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {imageData.map((item, index) => (
          <div key={index} className="flex flex-col items-center text-center">
            <img
              src={item.src}
              alt="Web Development Service"
              className="w-40 h-auto rounded-lg mb-4 shadow-md"
            />
            <p className="text-sm text-gray-600">{item.text}</p>
          </div>
        ))}
      </div>

      <Contactfooter />
      <style>
        {`
          @keyframes moveUpDown {
            0% { transform: translateY(0); }
            50% { transform: translateY(-20px); }
            100% { transform: translateY(0); }
          }
          .animate-moveUpDown {
            animation: moveUpDown 2s ease-in-out infinite;
          }
        `}
      </style>
    </>
  );
};

export default UXUi;
